<template>
  <div class="h-64 rounded-md">
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 100%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker
        :lat-lng="withPopup"
        :draggable="marker.draggable"
        @update:latLng="markerUpdate"
      >
        <l-popup>
          <div>Huidige accommodatie</div>
        </l-popup>
      </l-marker>

      <div class="otherAccommodaties">
        <l-marker
          v-for="accommodatie in accommodatiesInDistance"
          :lat-lng="accommodatie.latlon"
          :key="accommodatie.accommodatie_id"
        >
          <l-popup>
            <div
              @click="openAccomm(accommodatie.id)"
              class="cursor-pointer underline text-mi-blue-500"
            >
              {{ accommodatie.naam }}
            </div>
          </l-popup>
        </l-marker>
      </div>

      <l-control position="bottomleft" v-if="marker.draggable">
        <button @click="geocodeByAdress" title="Geocodeer op basis van adres">
          <i
            class="material-icons md-3xl bg-white p-1 rounded border-2 border-gray-500 hover:bg-gray-100"
            >system_update_alt</i
          >
        </button>
      </l-control>
    </l-map>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LControl } from "vue2-leaflet";

export default {
  name: "Map",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LControl
  },
  props: ["currentAccommodatieLatLon", "accommodatiesInDistance"],
  data() {
    return {
      zoom: 16,
      center: latLng(
        this.currentAccommodatieLatLon[0],
        this.currentAccommodatieLatLon[1]
      ),
      url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 16,
      currentCenter: this.withPopup,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      marker: {
        draggable:
          this.hasPermission("update accommodatie geometry") &&
          this.hasPermission("update accommodatie")
      },
      showMap: true
    };
  },
  computed: {
    withPopup: function() {
      return latLng(
        this.currentAccommodatieLatLon[0],
        this.currentAccommodatieLatLon[1]
      );
    }
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    markerUpdate(marker) {
      this.$store.dispatch("updateAccommodatieCoordinates", marker);
    },
    geocodeByAdress() {
      this.$store.dispatch("geocodeByAddress");
    },
    openAccomm: function(id) {
      if (this.$router.currentRoute.params.id !== id) {
        this.$router.push({ name: "Accommodatie", params: { id: id } });
      }
    }
  }
};
</script>

<style>
.leaflet-marker-pane :not(img.leaflet-marker-draggable) {
  filter: hue-rotate(230deg);
}
</style>
